var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1302.763,
    height: 198.652,
    viewBox: "0 0 1302.763 198.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "double-line",
    transform: "translate(11.382 -1609.679)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M-4,1081s286-338,618-87,342-172,684-85",
    transform: "translate(-7 713)",
    fill: "none",
    stroke: "#329d65",
    strokeWidth: 1,
    opacity: 0.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M1298,897s-286,338-618,87S338,1156-4,1069",
    transform: "translate(-7 727.003)",
    fill: "none",
    stroke: "#ceee36",
    strokeWidth: 1,
    opacity: 0.77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLine);
export default __webpack_public_path__ + "static/media/double-line.5aa0d3c42982fe41efb1dc805cb5b225.svg";
export { ForwardRef as ReactComponent };